import { centroid, polygon } from '@turf/turf';
import {
    isAreaEmissionInfo,
    isPlumeEmissionInfo,
    isTargetInfo,
    isTotalOnlyInfo,
    MSatPickInfo,
    UrlFeatureTypes
} from '../types';
import { getStacPlumeTimes } from './stac';

/**
 * Converts the info from a map click to the data needed to store it in state
 */
export const infoToSelectedFeatureParams = (
    prioritizedInfo: MSatPickInfo
): {
    featureType: UrlFeatureTypes;
    featureCoordinates: number[];
    featureDate: string;
    featureItemId: string;
    featureTargetId: string;
    collectionId: string | null;
    relatedRasterItemId?: string;
} => {
    if (isAreaEmissionInfo(prioritizedInfo)) {
        return {
            featureType: UrlFeatureTypes.AreaEmission,
            featureCoordinates: prioritizedInfo.coordinate,
            featureDate: prioritizedInfo.object.properties?.collectionStartTime,
            featureItemId: prioritizedInfo.layer.itemId,
            featureTargetId: prioritizedInfo.layer.parentTargetId,
            collectionId: prioritizedInfo.object.properties.collectionId
        };
    }

    if (isPlumeEmissionInfo(prioritizedInfo)) {
        return {
            featureType: UrlFeatureTypes.Plume,
            featureCoordinates: prioritizedInfo.object.geometry.coordinates,
            featureDate: getStacPlumeTimes(prioritizedInfo.object.properties).startTime,
            featureItemId: prioritizedInfo.object.itemId,
            featureTargetId: prioritizedInfo.object.parentTargetId,
            collectionId: prioritizedInfo.object.collection,
            relatedRasterItemId: prioritizedInfo.object.relatedRasterItemId
        };
    }

    if (isTargetInfo(prioritizedInfo) || isTotalOnlyInfo(prioritizedInfo)) {
        return {
            featureType: isTotalOnlyInfo(prioritizedInfo) ? UrlFeatureTypes.AreaEmission : UrlFeatureTypes.Target,
            featureCoordinates: centroid(polygon(prioritizedInfo.object.geometry.coordinates)).geometry.coordinates,
            featureDate: prioritizedInfo.object.properties?.start_datetime,
            featureItemId: prioritizedInfo.object.id,
            featureTargetId: prioritizedInfo.object.properties.target_id,
            collectionId: prioritizedInfo.object.collection
        };
    } else {
        // should never reach this, but TS requires an `else` statement
        throw new Error(`Unsupported map info`);
    }
};
